import Vue from 'vue'
import firebase from 'firebase'
export default firebase
import VueFire from 'vuefire'

Vue.use(VueFire)

export const fire = firebase.initializeApp({
  apiKey: 'AIzaSyDgCJJ9zChuCw3NpS2C0LrIhUVldxdtr9I',
  authDomain: 'lok-lok-academy.firebaseapp.com',
  databaseURL: 'https://lok-lok-academy.firebaseio.com',
  projectId: 'lok-lok-academy',
  storageBucket: 'lok-lok-academy.appspot.com',
  messagingSenderId: '809161638859'
})

export const db = fire.database()

export const getInitData = (projectID) => {
  return new Promise((resolve, reject) => {
    db.ref('/projects/' + projectID).once('value').then((snapshot) => {
      resolve(snapshot.val())
    })
  })
}



// WEBPACK FOOTER //
// ./src/firebase.js